import React from 'react';
import styled from 'styled-components/macro';
import { sizesMap, textLineHeight } from '../../typography/utils';
import { SPACINGS } from '../../utils/style';
import { TextAreaProps } from './TextArea';

const TextAreaStyled = styled.textarea<{ error: boolean }>`
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background-clip: padding-box;

  margin: 0;
  margin-bottom: ${(props) => (props.error ? SPACINGS[2] : 0)};
  padding: ${SPACINGS[2]} ${SPACINGS[5]};

  resize: vertical;
  background-color: transparent;
  min-height: ${SPACINGS[10]};
  width: ${(p) => p.theme.dimensions.inputWidth};
  border: 1px solid
    ${(props) =>
      props.error
        ? props.theme.colors.danger
        : props.theme.colors.secondary80w};
  border-radius: ${(p) => p.theme.dimensions.borderRadius};

  font-family: ${(props) => props.theme.fonts.gtEesti};
  font-size: ${sizesMap['base'].size};
  line-height: ${textLineHeight};

  &::placeholder {
    opacity: 0.5;
  }

  &:disabled {
    background-color: ${(props) => props.theme.colors.secondary90w};
    &:hover {
      cursor: not-allowed;
    }
  }

  &:not(:disabled) {
    &:hover {
      border: 1px solid
        ${(props) =>
          props.error ? props.theme.colors.danger : props.theme.colors.black};
    }
    &:focus {
      outline: none;
      background-color: ${(props) => props.theme.colors.white};
      border: 1px solid
        ${(props) =>
          props.error ? props.theme.colors.danger : props.theme.colors.black};
      box-shadow: 0 0 0 2px ${(props) => props.theme.colors.white},
        0 0 0 3px ${(props) => props.theme.colors.primary};
    }
  }
`;

function TextArea(props: TextAreaProps) {
  const { name, onChange, textAreaRef, placeholder, error, style } = props;

  return (
    <TextAreaStyled
      id={name}
      name={name}
      error={Boolean(error)}
      ref={textAreaRef}
      onChange={onChange}
      style={style}
      placeholder={placeholder}
    />
  );
}

export default TextArea;
